export const SDK_VERSION = '8.27.0';
